export const FeatureFlags = {
  PATIENT_FACING_VISIBILITY_TOGGLE: false,
};
